import React from "react";
import Image from "next/image";
import styled from "styled-components";
import Button from "components/Button";
import { Container } from "components/Grid";

const Hero = styled.section`
  position: relative;
  padding: 5rem 0;
  padding: 10vw 0;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  text-align: center;
  background-color: #333;

  &::after {
    content: " ";
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    display: block;
    width: 100%;
    height: 100%;
    background-color: rgba(139, 139, 139, 0.77);
  }

  @media (min-width: 640px) {
    padding: 8vw 0;
  }

  @media (min-width: 1200px) {
    padding: 9rem 0;
  }
`;

const Content = styled(Container)`
  position: relative;
  z-index: 1;
`;

const Title = styled.h1`
  margin-bottom: 4rem;
  font-size: 5rem;
  color: #fff;
`;

const CategoryHero = (props) => (
  <Hero image={props.image}>
    <Image src={props.image} alt={props.name} layout="fill" objectFit="cover" />

    <Content>
      <Title>{props.name}</Title>

      <Button href="/quiz/[slug]" as={`/quiz/${props.slug}`}>
        View Quiz
      </Button>
    </Content>
  </Hero>
);

export default CategoryHero;
